export default __webpack_public_path__ + "static/media/icons-train-green-48-px.41a81600.svg";